/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ZoteroUnmatchedRouteImport } from './routes/zotero/unmatched'
import { Route as SharedTokenRouteImport } from './routes/shared/$token'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings/integrations'
import { Route as SettingsBillingRouteImport } from './routes/settings/billing'
import { Route as ConceptsOverlapRouteImport } from './routes/concepts/overlap'
import { Route as ConceptsNewRouteImport } from './routes/concepts/new'
import { Route as ConceptsConceptIdRouteImport } from './routes/concepts/$conceptId'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminUsageRouteImport } from './routes/admin/usage'
import { Route as AdminMaintenanceRouteImport } from './routes/admin/maintenance'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin/announcements'
import { Route as AdminActivityRouteImport } from './routes/admin/activity'
import { Route as ConceptsConceptIdIndexRouteImport } from './routes/concepts/$conceptId/index'
import { Route as ConceptsConceptIdExpandRouteImport } from './routes/concepts/$conceptId/expand'
import { Route as ConceptsConceptIdEvidenceRouteImport } from './routes/concepts/$conceptId/evidence'
import { Route as ConceptsConceptIdCurateRouteImport } from './routes/concepts/$conceptId/curate'
import { Route as ConceptsConceptIdBuildRouteImport } from './routes/concepts/$conceptId/build'
import { Route as ConceptsConceptIdAnalyzeRouteImport } from './routes/concepts/$conceptId/analyze'
import { Route as ConceptsConceptIdImportOutlineRouteImport } from './routes/concepts/$conceptId/import/outline'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ZoteroUnmatchedRoute = ZoteroUnmatchedRouteImport.update({
  id: '/zotero/unmatched',
  path: '/zotero/unmatched',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedTokenRoute = SharedTokenRouteImport.update({
  id: '/shared/$token',
  path: '/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/settings/integrations',
  path: '/settings/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/settings/billing',
  path: '/settings/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const ConceptsOverlapRoute = ConceptsOverlapRouteImport.update({
  id: '/concepts/overlap',
  path: '/concepts/overlap',
  getParentRoute: () => rootRouteImport,
} as any)
const ConceptsNewRoute = ConceptsNewRouteImport.update({
  id: '/concepts/new',
  path: '/concepts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ConceptsConceptIdRoute = ConceptsConceptIdRouteImport.update({
  id: '/concepts/$conceptId',
  path: '/concepts/$conceptId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsageRoute = AdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMaintenanceRoute = AdminMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AdminRoute,
} as any)
const AdminActivityRoute = AdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AdminRoute,
} as any)
const ConceptsConceptIdIndexRoute = ConceptsConceptIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConceptsConceptIdRoute,
} as any)
const ConceptsConceptIdExpandRoute = ConceptsConceptIdExpandRouteImport.update({
  id: '/expand',
  path: '/expand',
  getParentRoute: () => ConceptsConceptIdRoute,
} as any)
const ConceptsConceptIdEvidenceRoute =
  ConceptsConceptIdEvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => ConceptsConceptIdRoute,
  } as any)
const ConceptsConceptIdCurateRoute = ConceptsConceptIdCurateRouteImport.update({
  id: '/curate',
  path: '/curate',
  getParentRoute: () => ConceptsConceptIdRoute,
} as any)
const ConceptsConceptIdBuildRoute = ConceptsConceptIdBuildRouteImport.update({
  id: '/build',
  path: '/build',
  getParentRoute: () => ConceptsConceptIdRoute,
} as any)
const ConceptsConceptIdAnalyzeRoute =
  ConceptsConceptIdAnalyzeRouteImport.update({
    id: '/analyze',
    path: '/analyze',
    getParentRoute: () => ConceptsConceptIdRoute,
  } as any)
const ConceptsConceptIdImportOutlineRoute =
  ConceptsConceptIdImportOutlineRouteImport.update({
    id: '/import/outline',
    path: '/import/outline',
    getParentRoute: () => ConceptsConceptIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/welcome': typeof WelcomeRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/maintenance': typeof AdminMaintenanceRoute
  '/admin/usage': typeof AdminUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/concepts/$conceptId': typeof ConceptsConceptIdRouteWithChildren
  '/concepts/new': typeof ConceptsNewRoute
  '/concepts/overlap': typeof ConceptsOverlapRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/shared/$token': typeof SharedTokenRoute
  '/zotero/unmatched': typeof ZoteroUnmatchedRoute
  '/concepts/$conceptId/analyze': typeof ConceptsConceptIdAnalyzeRoute
  '/concepts/$conceptId/build': typeof ConceptsConceptIdBuildRoute
  '/concepts/$conceptId/curate': typeof ConceptsConceptIdCurateRoute
  '/concepts/$conceptId/evidence': typeof ConceptsConceptIdEvidenceRoute
  '/concepts/$conceptId/expand': typeof ConceptsConceptIdExpandRoute
  '/concepts/$conceptId/': typeof ConceptsConceptIdIndexRoute
  '/concepts/$conceptId/import/outline': typeof ConceptsConceptIdImportOutlineRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/welcome': typeof WelcomeRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/maintenance': typeof AdminMaintenanceRoute
  '/admin/usage': typeof AdminUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/concepts/new': typeof ConceptsNewRoute
  '/concepts/overlap': typeof ConceptsOverlapRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/shared/$token': typeof SharedTokenRoute
  '/zotero/unmatched': typeof ZoteroUnmatchedRoute
  '/concepts/$conceptId/analyze': typeof ConceptsConceptIdAnalyzeRoute
  '/concepts/$conceptId/build': typeof ConceptsConceptIdBuildRoute
  '/concepts/$conceptId/curate': typeof ConceptsConceptIdCurateRoute
  '/concepts/$conceptId/evidence': typeof ConceptsConceptIdEvidenceRoute
  '/concepts/$conceptId/expand': typeof ConceptsConceptIdExpandRoute
  '/concepts/$conceptId': typeof ConceptsConceptIdIndexRoute
  '/concepts/$conceptId/import/outline': typeof ConceptsConceptIdImportOutlineRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/welcome': typeof WelcomeRoute
  '/admin/activity': typeof AdminActivityRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/maintenance': typeof AdminMaintenanceRoute
  '/admin/usage': typeof AdminUsageRoute
  '/admin/users': typeof AdminUsersRoute
  '/concepts/$conceptId': typeof ConceptsConceptIdRouteWithChildren
  '/concepts/new': typeof ConceptsNewRoute
  '/concepts/overlap': typeof ConceptsOverlapRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/shared/$token': typeof SharedTokenRoute
  '/zotero/unmatched': typeof ZoteroUnmatchedRoute
  '/concepts/$conceptId/analyze': typeof ConceptsConceptIdAnalyzeRoute
  '/concepts/$conceptId/build': typeof ConceptsConceptIdBuildRoute
  '/concepts/$conceptId/curate': typeof ConceptsConceptIdCurateRoute
  '/concepts/$conceptId/evidence': typeof ConceptsConceptIdEvidenceRoute
  '/concepts/$conceptId/expand': typeof ConceptsConceptIdExpandRoute
  '/concepts/$conceptId/': typeof ConceptsConceptIdIndexRoute
  '/concepts/$conceptId/import/outline': typeof ConceptsConceptIdImportOutlineRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/welcome'
    | '/admin/activity'
    | '/admin/announcements'
    | '/admin/maintenance'
    | '/admin/usage'
    | '/admin/users'
    | '/concepts/$conceptId'
    | '/concepts/new'
    | '/concepts/overlap'
    | '/settings/billing'
    | '/settings/integrations'
    | '/shared/$token'
    | '/zotero/unmatched'
    | '/concepts/$conceptId/analyze'
    | '/concepts/$conceptId/build'
    | '/concepts/$conceptId/curate'
    | '/concepts/$conceptId/evidence'
    | '/concepts/$conceptId/expand'
    | '/concepts/$conceptId/'
    | '/concepts/$conceptId/import/outline'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/welcome'
    | '/admin/activity'
    | '/admin/announcements'
    | '/admin/maintenance'
    | '/admin/usage'
    | '/admin/users'
    | '/concepts/new'
    | '/concepts/overlap'
    | '/settings/billing'
    | '/settings/integrations'
    | '/shared/$token'
    | '/zotero/unmatched'
    | '/concepts/$conceptId/analyze'
    | '/concepts/$conceptId/build'
    | '/concepts/$conceptId/curate'
    | '/concepts/$conceptId/evidence'
    | '/concepts/$conceptId/expand'
    | '/concepts/$conceptId'
    | '/concepts/$conceptId/import/outline'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/dashboard'
    | '/welcome'
    | '/admin/activity'
    | '/admin/announcements'
    | '/admin/maintenance'
    | '/admin/usage'
    | '/admin/users'
    | '/concepts/$conceptId'
    | '/concepts/new'
    | '/concepts/overlap'
    | '/settings/billing'
    | '/settings/integrations'
    | '/shared/$token'
    | '/zotero/unmatched'
    | '/concepts/$conceptId/analyze'
    | '/concepts/$conceptId/build'
    | '/concepts/$conceptId/curate'
    | '/concepts/$conceptId/evidence'
    | '/concepts/$conceptId/expand'
    | '/concepts/$conceptId/'
    | '/concepts/$conceptId/import/outline'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  WelcomeRoute: typeof WelcomeRoute
  ConceptsConceptIdRoute: typeof ConceptsConceptIdRouteWithChildren
  ConceptsNewRoute: typeof ConceptsNewRoute
  ConceptsOverlapRoute: typeof ConceptsOverlapRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SharedTokenRoute: typeof SharedTokenRoute
  ZoteroUnmatchedRoute: typeof ZoteroUnmatchedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/zotero/unmatched': {
      id: '/zotero/unmatched'
      path: '/zotero/unmatched'
      fullPath: '/zotero/unmatched'
      preLoaderRoute: typeof ZoteroUnmatchedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared/$token': {
      id: '/shared/$token'
      path: '/shared/$token'
      fullPath: '/shared/$token'
      preLoaderRoute: typeof SharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/concepts/overlap': {
      id: '/concepts/overlap'
      path: '/concepts/overlap'
      fullPath: '/concepts/overlap'
      preLoaderRoute: typeof ConceptsOverlapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/concepts/new': {
      id: '/concepts/new'
      path: '/concepts/new'
      fullPath: '/concepts/new'
      preLoaderRoute: typeof ConceptsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/concepts/$conceptId': {
      id: '/concepts/$conceptId'
      path: '/concepts/$conceptId'
      fullPath: '/concepts/$conceptId'
      preLoaderRoute: typeof ConceptsConceptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/usage': {
      id: '/admin/usage'
      path: '/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AdminUsageRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/maintenance': {
      id: '/admin/maintenance'
      path: '/maintenance'
      fullPath: '/admin/maintenance'
      preLoaderRoute: typeof AdminMaintenanceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/announcements': {
      id: '/admin/announcements'
      path: '/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AdminAnnouncementsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/activity': {
      id: '/admin/activity'
      path: '/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AdminActivityRouteImport
      parentRoute: typeof AdminRoute
    }
    '/concepts/$conceptId/': {
      id: '/concepts/$conceptId/'
      path: '/'
      fullPath: '/concepts/$conceptId/'
      preLoaderRoute: typeof ConceptsConceptIdIndexRouteImport
      parentRoute: typeof ConceptsConceptIdRoute
    }
    '/concepts/$conceptId/expand': {
      id: '/concepts/$conceptId/expand'
      path: '/expand'
      fullPath: '/concepts/$conceptId/expand'
      preLoaderRoute: typeof ConceptsConceptIdExpandRouteImport
      parentRoute: typeof ConceptsConceptIdRoute
    }
    '/concepts/$conceptId/evidence': {
      id: '/concepts/$conceptId/evidence'
      path: '/evidence'
      fullPath: '/concepts/$conceptId/evidence'
      preLoaderRoute: typeof ConceptsConceptIdEvidenceRouteImport
      parentRoute: typeof ConceptsConceptIdRoute
    }
    '/concepts/$conceptId/curate': {
      id: '/concepts/$conceptId/curate'
      path: '/curate'
      fullPath: '/concepts/$conceptId/curate'
      preLoaderRoute: typeof ConceptsConceptIdCurateRouteImport
      parentRoute: typeof ConceptsConceptIdRoute
    }
    '/concepts/$conceptId/build': {
      id: '/concepts/$conceptId/build'
      path: '/build'
      fullPath: '/concepts/$conceptId/build'
      preLoaderRoute: typeof ConceptsConceptIdBuildRouteImport
      parentRoute: typeof ConceptsConceptIdRoute
    }
    '/concepts/$conceptId/analyze': {
      id: '/concepts/$conceptId/analyze'
      path: '/analyze'
      fullPath: '/concepts/$conceptId/analyze'
      preLoaderRoute: typeof ConceptsConceptIdAnalyzeRouteImport
      parentRoute: typeof ConceptsConceptIdRoute
    }
    '/concepts/$conceptId/import/outline': {
      id: '/concepts/$conceptId/import/outline'
      path: '/import/outline'
      fullPath: '/concepts/$conceptId/import/outline'
      preLoaderRoute: typeof ConceptsConceptIdImportOutlineRouteImport
      parentRoute: typeof ConceptsConceptIdRoute
    }
  }
}

interface AdminRouteChildren {
  AdminActivityRoute: typeof AdminActivityRoute
  AdminAnnouncementsRoute: typeof AdminAnnouncementsRoute
  AdminMaintenanceRoute: typeof AdminMaintenanceRoute
  AdminUsageRoute: typeof AdminUsageRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminActivityRoute: AdminActivityRoute,
  AdminAnnouncementsRoute: AdminAnnouncementsRoute,
  AdminMaintenanceRoute: AdminMaintenanceRoute,
  AdminUsageRoute: AdminUsageRoute,
  AdminUsersRoute: AdminUsersRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ConceptsConceptIdRouteChildren {
  ConceptsConceptIdAnalyzeRoute: typeof ConceptsConceptIdAnalyzeRoute
  ConceptsConceptIdBuildRoute: typeof ConceptsConceptIdBuildRoute
  ConceptsConceptIdCurateRoute: typeof ConceptsConceptIdCurateRoute
  ConceptsConceptIdEvidenceRoute: typeof ConceptsConceptIdEvidenceRoute
  ConceptsConceptIdExpandRoute: typeof ConceptsConceptIdExpandRoute
  ConceptsConceptIdIndexRoute: typeof ConceptsConceptIdIndexRoute
  ConceptsConceptIdImportOutlineRoute: typeof ConceptsConceptIdImportOutlineRoute
}

const ConceptsConceptIdRouteChildren: ConceptsConceptIdRouteChildren = {
  ConceptsConceptIdAnalyzeRoute: ConceptsConceptIdAnalyzeRoute,
  ConceptsConceptIdBuildRoute: ConceptsConceptIdBuildRoute,
  ConceptsConceptIdCurateRoute: ConceptsConceptIdCurateRoute,
  ConceptsConceptIdEvidenceRoute: ConceptsConceptIdEvidenceRoute,
  ConceptsConceptIdExpandRoute: ConceptsConceptIdExpandRoute,
  ConceptsConceptIdIndexRoute: ConceptsConceptIdIndexRoute,
  ConceptsConceptIdImportOutlineRoute: ConceptsConceptIdImportOutlineRoute,
}

const ConceptsConceptIdRouteWithChildren =
  ConceptsConceptIdRoute._addFileChildren(ConceptsConceptIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  DashboardRoute: DashboardRoute,
  WelcomeRoute: WelcomeRoute,
  ConceptsConceptIdRoute: ConceptsConceptIdRouteWithChildren,
  ConceptsNewRoute: ConceptsNewRoute,
  ConceptsOverlapRoute: ConceptsOverlapRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SharedTokenRoute: SharedTokenRoute,
  ZoteroUnmatchedRoute: ZoteroUnmatchedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
